'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = VisualPickerOption;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _context = require('../VisualPicker/context');

var _utils = require('../../libs/utils');

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _checkmark = require('./checkmark');

var _checkmark2 = _interopRequireDefault(_checkmark);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable react/prop-types */


var PickerOption = function (_Component) {
  _inherits(PickerOption, _Component);

  function PickerOption(props) {
    _classCallCheck(this, PickerOption);

    var _this = _possibleConstructorReturn(this, (PickerOption.__proto__ || Object.getPrototypeOf(PickerOption)).call(this, props));

    _this.inputId = (0, _utils.uniqueId)('radio');
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(PickerOption, [{
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var className = this.props.className;
      return (0, _classnames2.default)('rainbow-visual-picker-option_content-container', className);
    }
  }, {
    key: 'getType',
    value: function getType() {
      var multiple = this.props.multiple;

      if (multiple) {
        return 'checkbox';
      }

      return 'radio';
    }
  }, {
    key: 'isChecked',
    value: function isChecked() {
      var _props = this.props,
          multiple = _props.multiple,
          name = _props.name,
          value = _props.value;

      if (multiple) {
        return Array.isArray(value) && value.includes(name);
      }

      return typeof value === 'string' && name === value;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      var _props2 = this.props,
          name = _props2.name,
          privateOnChange = _props2.privateOnChange;
      privateOnChange(name, event.target.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          disabled = _props3.disabled,
          children = _props3.children,
          footer = _props3.footer,
          style = _props3.style;
      var _props4 = this.props,
          groupName = _props4.groupName,
          ariaDescribedby = _props4.ariaDescribedby;
      return _react2.default.createElement('span', {
        className: this.getContainerClassNames(),
        style: style
      }, _react2.default.createElement('input', {
        className: 'rainbow-visual-picker-option_input',
        type: this.getType(),
        id: this.inputId,
        name: groupName,
        checked: this.isChecked(),
        'aria-describedby': ariaDescribedby,
        onChange: this.handleChange,
        disabled: disabled
      }), _react2.default.createElement('label', {
        className: 'rainbow-visual-picker-option_content',
        htmlFor: this.inputId
      }, _react2.default.createElement('span', {
        className: 'rainbow-visual-picker-option'
      }, _react2.default.createElement(_RenderIf2.default, {
        isTrue: this.isChecked()
      }, _react2.default.createElement('span', {
        className: 'rainbow-visual-picker-option_selected-element'
      }), _react2.default.createElement(_checkmark2.default, {
        className: 'rainbow-visual-picker-option_checkmark-icon'
      })), children), _react2.default.createElement(_RenderIf2.default, {
        isTrue: !!footer
      }, _react2.default.createElement('footer', {
        className: 'rainbow-visual-picker-option_footer'
      }, footer))));
    }
  }]);

  return PickerOption;
}(_react.Component);
/**
 * A VisualPickerOption.
 * @category Form
 */


function VisualPickerOption(props) {
  return _react2.default.createElement(_context.Consumer, null, function (context) {
    return _react2.default.createElement(PickerOption, _extends({}, props, context));
  });
}

VisualPickerOption.propTypes = {
  /** It is a unique value that identifies the picker option. */
  name: _propTypes2.default.string.isRequired,

  /** It is what will be displayed at the bottom of the component. */
  footer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),

  /** Specifies that an VisualPickerOption element should be disabled.
   * This value defaults to false. */
  disabled: _propTypes2.default.bool,

  /** The class name of the root element. */
  className: _propTypes2.default.string,

  /** It is an object with custom style applied to the root element. */
  style: _propTypes2.default.object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.object])
};
VisualPickerOption.defaultProps = {
  name: undefined,
  footer: undefined,
  disabled: false,
  className: undefined,
  style: undefined,
  children: [],
  ariaDescribedby: undefined
};